import { Banner as BannerComponent } from './Banner';
import { Card as CardComponent } from './Card';
import { ContactInfo as ContactInfoComponent } from './ContactInfo';
import { Form as FormComponent } from './Form';
import { Gallery as GalleryComponent } from './Gallery';
import { Iframe as IframeComponent } from './Iframe';
import { LinkTile as LinkTileComponent } from './LinkTile';
import { LogoSlider as LogoSliderComponent } from './LogoSlider';
import { Navigation as NavigationComponent } from './Navigation';
import { NewsroomAssets as NewsroomAssetsComponent } from './NewsroomAssets';
import { NewsroomFooter as NewsroomFooterComponent } from './NewsroomFooter';
import { NewsroomHeader as NewsroomHeaderComponent } from './NewsroomHeader';
import { NewsroomNews as NewsroomNewsComponent } from './NewsroomNews';
import { ProductBoxList as ProductBoxListComponent } from './ProductBoxList';
import { ProductBoxListV2 as ProductBoxListV2Component } from './ProductBoxListV2';
import { RichText as RichTextComponent } from './RichText';
import { SectionTitle as SectionTitleComponent } from './SectionTitle';
import { TextMedia as TextMediaComponent } from './TextMedia';
import { withContainer } from './withContainer';

const Banner = withContainer(BannerComponent);
const Card = withContainer(CardComponent);
const ContactInfo = withContainer(ContactInfoComponent);
const Form = withContainer(FormComponent);
const Gallery = withContainer(GalleryComponent);
const Iframe = withContainer(IframeComponent);
const LinkTile = withContainer(LinkTileComponent);
const LogoSlider = withContainer(LogoSliderComponent);
const Navigation = withContainer(NavigationComponent);
const NewsroomAssets = withContainer(NewsroomAssetsComponent);
const NewsroomNews = withContainer(NewsroomNewsComponent);
const ProductBoxList = withContainer(ProductBoxListComponent);
const ProductBoxListV2 = withContainer(ProductBoxListV2Component);
const NewsroomHeader = withContainer(NewsroomHeaderComponent);
const NewsroomFooter = withContainer(NewsroomFooterComponent);
const RichText = withContainer(RichTextComponent);
const SectionTitle = withContainer(SectionTitleComponent);
const TextMedia = withContainer(TextMediaComponent);

export {
  Banner,
  BannerComponent,
  Card,
  CardComponent,
  ContactInfo,
  ContactInfoComponent,
  Form,
  FormComponent,
  Gallery,
  GalleryComponent,
  Iframe,
  IframeComponent,
  LinkTile,
  LinkTileComponent,
  LogoSlider,
  LogoSliderComponent,
  Navigation,
  NavigationComponent,
  NewsroomAssets,
  NewsroomAssetsComponent,
  NewsroomFooter,
  NewsroomHeader,
  NewsroomNews,
  NewsroomNewsComponent,
  ProductBoxList,
  ProductBoxListComponent,
  ProductBoxListV2,
  ProductBoxListV2Component,
  RichText,
  RichTextComponent,
  SectionTitle,
  SectionTitleComponent,
  TextMedia,
  TextMediaComponent,
};

export * from './withContainer';
